var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jobtype" }, [
    _vm.use_radio
      ? _c("div", { staticClass: "group" }, [
          _c("input", {
            staticClass: "radio",
            attrs: {
              type: "radio",
              id: "AAA",
              name: "job",
              value: "AAA",
              checked: ""
            },
            on: {
              click: function($event) {
                return _vm.radioSelect("5• AAA")
              }
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "AAA" } }, [_vm._v("AAA")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.use_radio
      ? _c("div", { staticClass: "group" }, [
          _c("input", {
            staticClass: "radio",
            attrs: { type: "radio", id: "AAD", name: "job", value: "AAD" },
            on: {
              click: function($event) {
                return _vm.radioSelect("6• AAD")
              }
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "AAD" } }, [_vm._v("AAD")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.use_radio
      ? _c("div", { staticClass: "group" }, [
          _c("input", {
            staticClass: "radio",
            attrs: {
              type: "radio",
              id: "AAA_AAD",
              name: "job",
              value: "AAA_AAD"
            },
            on: {
              click: function($event) {
                return _vm.radioSelect("5• AAA,6• AAD")
              }
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "AAA_AAD" } }, [_vm._v("AAA + AAD")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.use_radio
      ? _c("div", { staticClass: "group" }, [
          _c("input", {
            staticClass: "radio",
            attrs: {
              type: "radio",
              id: "COM_AAD",
              name: "job",
              value: "COM_AAD"
            },
            on: {
              click: function($event) {
                return _vm.radioSelect("9• COM,6• AAD")
              }
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "COM_AAD" } }, [_vm._v("COM + AAD")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.use_radio
      ? _c(
          "div",
          { staticClass: "group" },
          [
            _c("input", {
              staticClass: "radio",
              attrs: {
                type: "radio",
                id: "OTHER",
                name: "job",
                value: "OTHER"
              },
              on: {
                click: function($event) {
                  return _vm.radioSelect("OTHER")
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticStyle: { "margin-right": "10px" },
                attrs: { for: "OTHER" }
              },
              [_vm._v("OTHER")]
            ),
            _vm._v(" "),
            _vm.other == true
              ? _c("autocomplete", {
                  staticStyle: { width: "200px", float: "right" },
                  attrs: {
                    selectable: true,
                    index: 0,
                    type: 0,
                    fixed: _vm.fixed
                  },
                  on: { input: _vm.setData }
                })
              : _c("autocomplete", {
                  staticStyle: { width: "200px", float: "right" },
                  attrs: {
                    selectable: false,
                    index: 0,
                    type: 0,
                    fixed: _vm.fixed
                  },
                  on: { input: _vm.setData }
                })
          ],
          1
        )
      : _c(
          "div",
          [
            _c("autocomplete", {
              staticStyle: { width: "100%" },
              attrs: { index: 0, value: _vm.search, type: 0, fixed: _vm.fixed },
              on: { input: _vm.setData }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fab83a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fab83a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/jobtype.vue
// module id = 803
// module chunks = 0